import iterableObject from '@/utils/iterableObject';

const shippingMethods = {
    email: {
        text: 'ShippingMethod.email',
        value: 'Email'
    },
    post: {
        text: 'ShippingMethod.postage',
        value: 'Post'
    },
    giftBox: {
        text: 'ShippingMethod.giftbox',
        value: 'GiftBox'
    }
};

Object.setPrototypeOf(shippingMethods, iterableObject);

export default shippingMethods;
